<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-领取记录
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="用户"><el-input v-model="formInline.user_name" placeholder="请输入用户名"></el-input></el-form-item>
          <el-form-item label="优惠券" ><el-input v-model="formInline.name" placeholder="请输入优惠券名称"></el-input></el-form-item>
          <el-form-item label="卡号" ><el-input v-model="formInline.card_no" placeholder="请输入卡号"></el-input></el-form-item>
          <!-- <el-form-item label="是否使用">
            <el-select v-model="formInline.is_use" placeholder="请选择使用情况" style="width: 108px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option v-for="(item, index) in is_use" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="卡类型">
            <el-select v-model="formInline.coupon_type" placeholder="请选择卡类型" style="width: 108px;">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="满减券" :value="10"></el-option>
              <el-option label="折扣券" :value="20"></el-option>
              <el-option label="礼品卡" :value="30"></el-option>
              <el-option label="充值卡" :value="40"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否使用">
            <el-select v-model="formInline.is_use" placeholder="请选择使用情况" style="width: 108px;">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="已使用" :value="1"></el-option>
              <el-option label="未使用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否领取">
            <el-select v-model="formInline.is_receive" placeholder="请选择使用情况" style="width: 108px;">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="已领取" :value="1"></el-option>
              <el-option label="未领取" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
          <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user.nickName" label="用户">
              <template slot-scope="scope">
                {{ scope.row.user ? scope.row.user.nickName : '无主' }}
              </template>
            </el-table-column>
            <el-table-column prop="coupon_id" label="优惠券ID"></el-table-column>
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
            <el-table-column prop="coupon_type" label="优惠券类型"></el-table-column>
            <el-table-column prop="store.store_name" label="门店名称"></el-table-column>
            <el-table-column prop="card_no" label="卡号"></el-table-column>
            <el-table-column prop="card_pwd" label="密码"></el-table-column>
            <el-table-column prop="min_price" label="最低消费金额"></el-table-column>
            <el-table-column prop="price" label="卡余额"></el-table-column>
            <el-table-column prop="nprice" label="激活费用"></el-table-column>
            <el-table-column prop="seckill_stock" label="优惠方式">
              <template slot-scope="scope">
                <div v-if="scope.row.coupon_type.value==10">
                  <span>立减 <strong class="orange">{{scope.row.reduce_price}}</strong> 元</span>
                </div>
                <div v-if="scope.row.coupon_type.value==20">
                  <span>打 <strong class="orange">{{scope.row.discount}}</strong> 折</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="usage_count" label="剩余次数"></el-table-column>
            <el-table-column prop="isuse" label="是否使用">
              <template slot-scope="scope">
                <div v-if="scope.row.is_use==0">
                  <span>未使用</span>
                </div>
                <div v-if="scope.row.is_use==1">
                  <span>已使用</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="isuse" label="是否领取">
              <template slot-scope="scope">
                <div v-if="scope.row.user && scope.row.user.user_id>0">
                  <span>已领取</span>
                </div>
                <div v-else>
                  <span>未领取</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="seckill_stock" label="有效期">
              <template slot-scope="scope">
                <div v-if="scope.row.expire_type==10">
                  <span>领取 <strong class="orange">{{scope.row.expire_day}}</strong> 天内有效</span>
                </div>
                <div v-if="scope.row.expire_type==20">
                  <span>
                    {{scope.row.start_time.text}}
                    ~
                    {{scope.row.end_time.text}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="领取时间"></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="Number(scope.row.coupon_type.value) === 40" 
                @click="rechargeClick(scope.row)" type="text" size="small">充值</el-button>
              
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="formInline.page"
           :page-size="formInline.list_rows" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <Recharge v-if="open_add" :open_add="open_add" :form="userModel"  @closeDialog="closeDialogFunc($event, 'add')"></Recharge>

  </div>
</template>
<script>
  import CouponApi from '@/api/coupon.js';
  import Recharge from './dialog/Recharge.vue';
  import qs from 'qs';
  export default {
    components:{
      Recharge
    },
    data() {
      return {
        formInline: {
          user_name: '',
          name:'',
          is_use: -1,
          card_no:'',
          is_receive: -1,
          list_rows: 20,
          page: 1,
          coupon_type:-1,
        },
        form: {},
        tableData: [],
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*是否加载完成*/
        loading: true,
        // is_use:['未使用','已使用'],

        open_add:false,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
          /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    },
      rechargeClick(e){
          this.userModel = e;
          this.open_add = true

      },
      /*获取列表*/
      getData() {
        let self = this;
        CouponApi.receiveList(self.formInline, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getData();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.formInline.page = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.formInline.page = 1;
        this.getTableList();
      },
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/shop/plus.coupon.coupon/export?' + qs.stringify(this.formInline);
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/Receive.vue